import "core-js/modules/es.array.for-each";
import "core-js/modules/es.number.constructor";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var path = process.env.VUE_APP_BASE_API;
import { findStationBaseInfo } from '@/api/bairun/stationBaseInfo'; //  油站信息

import { getStationOilEngineInfoList } from '@/api/bairun/stationOilEngineInfo'; //  油机信息

import { getStationOilTankInfoList } from '@/api/bairun/stationOilTankInfo'; //  油罐信息

import { createStationOilGunInfo, deleteStationOilGunInfo } from '@/api/bairun/stationOilGunInfo';
import { getBairunStationAllBasePrice } from '@/api/bairun/stationBasePrice'; //  此处请自行替换地址

import infoList from '@/mixins/infoList';
import { getDict } from '@/utils/dictionary'; // 获取字典数据的func

import { mapGetters } from 'vuex';

var _this;

export default {
  name: 'StationDeviceInfo',
  components: {},
  mixins: [infoList],
  data: function data() {
    return {
      actionType: null,
      fullscreenLoading: false,
      path: path,
      listApi: getStationOilEngineInfoList,
      stationBaseInfo: [],
      tankData: [],
      oilGunStatusDict: [],
      dialogFormVisible: false,
      deleteVisible: false,
      countryPriceTitle: [],
      countryPriceData: [{
        title: '国家价',
        price92: '7.08',
        price95: '7.68',
        price98: '7.88',
        price0: '6.18'
      }, {
        title: '挂牌价',
        price92: '6.08',
        price95: '6.68',
        price98: '6.88',
        price0: '5.18'
      }],
      formData: {
        stationId: null,
        stationName: null,
        stationOilTankData: {
          tankId: null,
          tankName: null,
          tankNo: null,
          oilCode: null
        },
        stationOilTankId: null,
        oilCode: null,
        stationOilEngineId: null,
        oilGunNo: null,
        oilGunStatus: null,
        oilGunRemark: null
      },
      rules: {
        stationId: [{
          required: true,
          message: '请选择需要配置的油站',
          trigger: 'blur'
        }],
        oilGunNo: [{
          required: true,
          message: '请输入油枪号',
          trigger: 'blur'
        }],
        oilGunStatus: [{
          required: true,
          message: '请输入油枪状态',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  // eslint-disable-next-line vue/order-in-components
  filters: {
    formatColor: function formatColor(code) {
      return 'primary'; // switch (code) {
      //   case 92:
      //     return 'primary'
      //   case 95:
      //     return 'success'
      //   case 98:
      //     return 'info'
      //   case 0:
      //     return 'warning'
      // }
    }
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.searchInfo.stationId = Number(_this3.$route.params.stationId);
                _this3.formData.stationId = Number(_this3.$route.params.stationId);
                _context3.next = 4;
                return _this3.getTableData();

              case 4:
                _context3.next = 6;
                return _this3.setStartMap();

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.formData = {
        stationId: null,
        stationName: null,
        stationOilTankData: {
          tankId: null,
          tankName: null,
          tankNo: null,
          oilCode: null
        },
        stationOilTankId: null,
        oilCode: null,
        stationOilEngineId: null,
        oilGunNo: null,
        oilGunStatus: null,
        oilGunRemark: null
      };
    },
    enterDialog: function enterDialog() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this4.$refs['elForm'].validate( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(valid) {
                    var res;
                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            if (valid) {
                              _context4.next = 2;
                              break;
                            }

                            return _context4.abrupt("return");

                          case 2:
                            _context4.t0 = _this4.actionType;
                            _context4.next = _context4.t0 === 'add' ? 5 : 9;
                            break;

                          case 5:
                            _context4.next = 7;
                            return createStationOilGunInfo(_this4.formData);

                          case 7:
                            res = _context4.sent;
                            return _context4.abrupt("break", 11);

                          case 9:
                            _this4.$message({
                              type: 'info',
                              message: '无效操作'
                            });

                            return _context4.abrupt("return");

                          case 11:
                            if (!(res.code === 0)) {
                              _context4.next = 18;
                              break;
                            }

                            _this4.$message({
                              type: 'success',
                              message: '操作成功'
                            });

                            _this4.closeDialog();

                            _context4.next = 16;
                            return _this4.getTableData();

                          case 16:
                            _context4.next = 18;
                            return _this4.getTankData();

                          case 18:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 唤起弹窗 新增油枪
    addOilGun: function addOilGun(item) {
      console.log(item);
      this.actionType = 'add';
      this.dialogFormVisible = true;
      this.formData.stationId = item.station.ID;
      this.formData.stationName = item.station.stationName;
      this.formData.stationOilEngineId = item.ID;
    },
    tankSelectChange: function tankSelectChange(item) {
      this.formData.stationOilTankData.tankId = item.tankId;
      this.formData.stationOilTankData.oilCode = item.oilCode;
      this.formData.stationOilTankData.tankName = item.tankName;
      this.formData.stationOilTankData.tankNo = item.tankNo;
      this.formData.stationOilTankId = item.tankId;
      this.formData.oilCode = item.oilCode;
      console.log(this.formData);
    },
    deleteOilGun: function deleteOilGun(id) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this5.$confirm('此操作将删除此油枪, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                  var res;
                  return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          _context6.next = 2;
                          return deleteStationOilGunInfo({
                            ID: id
                          });

                        case 2:
                          res = _context6.sent;

                          if (!(res.code === 0)) {
                            _context6.next = 9;
                            break;
                          }

                          _this5.$message({
                            type: 'success',
                            message: '删除成功!'
                          });

                          _context6.next = 7;
                          return _this5.getTableData();

                        case 7:
                          _context6.next = 9;
                          return _this5.getTankData();

                        case 9:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6);
                }))).catch(function () {
                  _this5.$message({
                    type: 'info',
                    message: '已取消删除操作'
                  });
                });

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    setStartMap: function setStartMap() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var res;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return getDict('oilGunStatus');

              case 2:
                _this6.oilGunStatusDict = _context8.sent;
                _context8.next = 5;
                return findStationBaseInfo({
                  ID: _this6.searchInfo.stationId
                });

              case 5:
                res = _context8.sent;

                if (res.code === 0) {
                  _this6.stationBaseInfo = res.data.resStationBaseInfo;
                }

                _this6.getTankData();

                _this6.getPriceData();

              case 9:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    getTankData: function getTankData() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var res;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return getStationOilTankInfoList({
                  stationId: _this7.searchInfo.stationId,
                  page: 1,
                  pageSize: 999
                });

              case 2:
                res = _context9.sent;

                if (!(res.code != 0)) {
                  _context9.next = 6;
                  break;
                }

                _this7.$message({
                  type: 'error',
                  message: res.msg
                });

                return _context9.abrupt("return");

              case 6:
                _this7.tankData = res.data.list;

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    getPriceData: function getPriceData() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var res, countryPriceTitle, countryPriceData;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return getBairunStationAllBasePrice({
                  stationId: _this8.searchInfo.stationId
                });

              case 2:
                res = _context10.sent;

                if (!(res.code != 0)) {
                  _context10.next = 6;
                  break;
                }

                _this8.$message({
                  type: 'error',
                  message: res.msg
                });

                return _context10.abrupt("return");

              case 6:
                countryPriceTitle = [];
                countryPriceData = [{
                  title: '国家价'
                }, {
                  title: '挂牌价'
                }];
                res.data.forEach(function (item) {
                  countryPriceTitle.push({
                    oilCode: item.oilCode,
                    title: 'price' + item.oilCode
                  });
                  countryPriceData[0]['price' + item.oilCode] = item.countryPrice;
                  countryPriceData[1]['price' + item.oilCode] = item.stationPrice;
                });
                _this8.countryPriceTitle = countryPriceTitle;
                _this8.countryPriceData = countryPriceData;

                _this8.$forceUpdate();

              case 12:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    }
  }
};